export default __webpack_public_path__ + "static/mars-surface-e649467439c6ad645e79f613575f2898.png";